import type { ComponentType, ReactNode } from 'react';

interface Props {
  label: string;
  value: string;
  sub?: string;
  icon: ComponentType<{ className?: string }>;
  color: string;
  onClick?: () => void;
  children?: ReactNode;
}

export default function KpiCard({ label, value, sub, icon: Icon, color, onClick, children }: Props) {
  const clickable = typeof onClick === 'function';
  return (
    <div
      onClick={onClick}
      className={`bg-white dark:bg-gray-800 rounded-xl shadow p-4 border-l-4 ${color} ${
        clickable ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''
      }`}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.(); } } : undefined}
    >
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <p className="text-sm text-gray-500 dark:text-gray-400 truncate">{label}</p>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">{value}</p>
          {sub && <p className="text-xs text-gray-400 dark:text-gray-500 mt-1 truncate">{sub}</p>}
          {children}
        </div>
        <Icon className="w-8 h-8 text-gray-300 dark:text-gray-600 flex-shrink-0" />
      </div>
    </div>
  );
}
